import $ from 'jquery'
import { isActive } from '../_variables'

export default class Format {
  constructor() {
    this.elm = document.querySelector('html')
  }

  init() {
    this.format()
  }

  format() {
  $('.js-activeTitle').on('click', function() {
    var index = $('.js-activeTitle').index(this);
    $('.js-activeTitle').removeClass(isActive);
    $(this).addClass(isActive);
    $('.js-activeImage').removeClass(isActive).eq(index).addClass(isActive);
    $('.js-activeDetail').removeClass(isActive).eq(index).addClass(isActive);
  });
 }
}
